import store from 'store';
import ModuleConfig from '../Module.json';

class Storage {
  static cookLocalStorageKey(key) {
    return key ? `${ModuleConfig.id}_${key}` : null;
  }

  static setLocalStorage(key, value, exp) {
    if (key && value) {
      const formatedKey = this.cookLocalStorageKey(key);
      store.set(formatedKey, {
        value,
        exp: exp || null,
        time: new Date().getTime(),
      });
      return store.get(formatedKey);
    }
    return null;
  }

  static getLocalStorage(key) {
    const info = store.get(this.cookLocalStorageKey(key));

    if (!info || typeof info === 'undefined') return null;
    if (info.exp && new Date().getTime() - info.time > info.exp) return null;

    return info.value;
  }

  static removeLocalStorage(key) {
    const formatedKey = this.cookLocalStorageKey(key);
    const info = store.get(formatedKey);

    if (!info || typeof info === 'undefined') return null;

    store.set(formatedKey, {
      value: null,
      exp: null,
      time: new Date().getTime(),
    });
    return true;
  }
}

export default Storage;



// WEBPACK FOOTER //
// ./src/helpers/storage.js